const indexItems = [
  { title: '户外竞技综艺', count: '86 档', icon: 'ri-run-line', color: 'primary' },
  { title: '音乐竞演综艺', count: '52 档', icon: 'ri-music-line', color: 'accent' },
  { title: '喜剧脱口秀', count: '38 档', icon: 'ri-emotion-laugh-line', color: 'secondary' },
  { title: '悬疑推理综艺', count: '24 档', icon: 'ri-search-eye-line', color: 'primary' },
  { title: '恋爱观察综艺', count: '31 档', icon: 'ri-heart-line', color: 'accent' },
  { title: '生活慢综艺', count: '29 档', icon: 'ri-home-heart-line', color: 'secondary' },
  { title: '舞蹈竞技综艺', count: '18 档', icon: 'ri-music-2-line', color: 'primary' },
];

const colorMap: Record<string, { bg: string; text: string; icon: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600', icon: 'bg-primary-100 text-primary-600' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600', icon: 'bg-accent-100 text-accent-600' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', icon: 'bg-secondary-100 text-secondary-600' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4 whitespace-nowrap">
              主题索引
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              按品类探索综艺世界
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              七大综艺品类，总有一类适合你的口味，点击探索更多精彩内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {indexItems.slice(0, 3).map((item) => {
              const c = colorMap[item.color];
              return (
                <div
                  key={item.title}
                  className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200 hover:border-primary-200 transition-all cursor-pointer group"
                >
                  <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${c.icon} mb-4 group-hover:scale-110 transition-transform`}>
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{item.count}</span>
                    <span className="text-xs text-primary-500 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                      浏览 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-4 md:mt-5">
            {indexItems.slice(3).map((item) => {
              const c = colorMap[item.color];
              return (
                <div
                  key={item.title}
                  className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200 hover:border-primary-200 transition-all cursor-pointer group"
                >
                  <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${c.icon} mb-4 group-hover:scale-110 transition-transform`}>
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{item.count}</span>
                    <span className="text-xs text-primary-500 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                      浏览 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}